import React from 'react'

import { CSSTransition } from 'react-transition-group'

import styles from './Backdrop.module.scss'

type BackdropProps = {
  children?: React.ReactNode
  isVisible: boolean
  timeout?: number
}

export const Backdrop = ({
  children,
  timeout = 3600000,
  isVisible,
}: BackdropProps) => {
  const ref = React.useRef<HTMLDivElement>(null)

  return (
    <CSSTransition
      className={styles.backdrop}
      classNames={{
        appear: styles.appear,
        appearActive: styles.appearActive,
        enter: styles.enter,
        enterActive: styles.enterActive,
        exit: styles.exit,
        exitActive: styles.exitActive,
      }}
      nodeRef={ref}
      timeout={timeout}
      in={isVisible}
      appear
      mountOnEnter
      unmountOnExit
    >
      <div className={styles.backdrop} {...{ ref }}>
        {children}
      </div>
    </CSSTransition>
  )
}
